import translations from './translate';

let available = {};

export default function codes(langs) {
    Object.keys(langs).forEach(key => {
        let ISO639 = key.split('_')[0]; // Language Alpha2 code

        let ISO3116 = translations[ISO639];
        if (ISO3116) {
            available[key] = {
                code: ISO3116,
                class: `flag-icon flag-icon-${ISO3116.toLowerCase()}`
            };
        }
    });
    return available;
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/codes/index.js